<label class="option__wrapper">
    <input
            type="radio"
            [checked]="checked"
            [value]="value"
            [name]="name"
            (change)="onInput()"
    />
    <div class="option">
        <div class="option__content">
            <div class="option__image">
                <ng-content select="[option__image]"></ng-content>
            </div>
            <div class="option__label">
                <ng-content select="[option__label]" ></ng-content>
            </div>

        </div>
    </div>


</label>